/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 * @author    Afternet <info@afternet.gr>
 * @copyright 2022 Afternet
 * @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, {useState} from 'react';
import {ReactComponent as ArrowDown} from "../assets/img/faq/arrow-down-green.svg";

const FaqAccordion = (props) => {

    const [open, setOpen] = useState(false);

    function clickHundler(){
        setOpen(!open);
    }

    return (
        <div className={`FaqAccordion ${open ? "opened" : ""}`}>
            <div className='FaqAccordion__header' onClick={clickHundler}>
                <div className='FaqAccordion__title'>{props.title}</div>
                <div className='FaqAccordion__arrow'><ArrowDown/></div>
            </div>
            {open && <div className='FaqAccordion__body'>
                {props.content}
            </div>}
        </div>
    );
};

export default FaqAccordion;
